import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { campsenum } from '../../../models/enums.generated';
import { camps } from '../../../models/models.generated';
import { CampCategory } from '../models/camp-category.model';
import { CampSubcategory } from '../models/camp-subcategory.model';
import { CampType } from '../models/camp-type.model';

@Injectable({
    providedIn: 'root',
})
export class CampCategoryService {
    private translateService = inject(TranslateService);

    private allCategories: camps.CategoryModel[] = [];
    private parentCategories: camps.CategoryModel[] = [];
    private subcategories: camps.CategoryModel[] = [];
    private campTypes: CampType[] = [];

    private categoriesWithSubcategories: CampCategory[] = [];

    initializeService(categories: camps.CategoryModel[]): void {
        this.allCategories = categories;
        this.parentCategories = categories.filter((cat) => !cat.parentId);
        this.subcategories = categories.filter((cat) => cat.parentId);

        const categoriesWithSubcategories = this.getCategoriesWithSubcategories();

        this.campTypes = Object.keys(campsenum.CampType).map((x) => {
            const name = this.translateService.instant('CampType.' + campsenum.CampType[x]);
            const result: CampType = {
                name: name,
                number: +x,
                campCategories: categoriesWithSubcategories.filter((cat) => {
                    return cat.campTypeNumber === +x;
                }),
            };

            return result;
        });
    }

    cleanupService(): void {
        this.allCategories = [];
        this.parentCategories = [];
        this.subcategories = [];
        this.campTypes = [];
        this.categoriesWithSubcategories = [];
    }

    getAllCategories(): camps.CategoryModel[] {
        return this.allCategories;
    }

    getParentCategories(): camps.CategoryModel[] {
        return this.parentCategories;
    }

    getSubcategories(): camps.CategoryModel[] {
        return this.subcategories;
    }

    getCampTypes(): CampType[] {
        return this.campTypes;
    }

    getCategoriesWithSubcategories(): CampCategory[] {
        if (this.categoriesWithSubcategories.length > 0) {
            return this.categoriesWithSubcategories;
        }

        const subcategories = this.subcategories.map((sub) => {
            const subcategoryModel: CampSubcategory = {
                id: sub.id,
                name: sub.name,
                parentCategoryId: sub.parentId!,
                photoUrl: signal<string | undefined | null>(undefined),
                photoBelongsToParentCategory: false,
            };

            return subcategoryModel;
        });

        const result = this.parentCategories.map((parent) => {
            const parentCategory: CampCategory = {
                campTypeNumber: parent.campType,
                id: parent.id,
                name: parent.name,
                campSubcategories: subcategories.filter((sub) => sub.parentCategoryId === parent.id),
                photoUrl: signal<string | undefined | null>(undefined),
            };

            return parentCategory;
        });

        this.categoriesWithSubcategories = result;
        return result;
    }
}
